import type { ReactNode } from "react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";
import { DEMO_NO_SAVE_MESSAGE } from "@buildpy/core/modules/demo/routes";

interface Props {
  children: ReactNode;
  className?: string;
  variant?: "primary" | "outline" | "link";
  size?: "default" | "sm";
}

// 실제 화면에서 서버 액션이 붙는 버튼의 자리 — 데모에서는 안내 토스트만 띄운다.
const DemoNoSaveButton = ({ children, className, variant = "primary", size = "default" }: Props) => (
  <Button className={className} size={size} type="button" variant={variant} onClick={() => toast(DEMO_NO_SAVE_MESSAGE)}>
    {children}
  </Button>
);

export default DemoNoSaveButton;
